import { AccountRefCode, PagingResponse, RefCode } from "@app/types";
import HttpService from "@core/services/http/http.service";

class _RefCodeService {
  public getAllRefCodes() {
    return HttpService.get<RefCode[]>("/ref-codes");
  }

  public getAccountsByRefCode(page: number) {
    return HttpService.get<PagingResponse<AccountRefCode>>(
      "/ref-codes/accounts",
      { queryParams: { page } }
    );
  }
}

const RefCodeService = new _RefCodeService();

export default RefCodeService;
